// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"511":"362815fd","849":"6f4b2b39","880":"362815fd","960":"7484773a"}[chunkId] + ".chunk.css";
};